import React, { useState } from 'react'
import { gql, useQuery } from 'urql'
import CarouselGetInspired from 'components/carousels/CarouselGetInspired'
import { isServer } from 'data/helpers/ssr'

const GetInspiredSection = () => {

  const [selectedDestination, setSelectedDestination] = useState(-1)

  const [{ data: regions, fetching: fetchingRegions }] = useQuery({
    query: gql`
      query Regions(
        $orderBy: [DestinationRegionOrderByOrderByClause!]
      ) {
        regions(first: 50, orderBy: $orderBy) {
          data {
            id
            value
            popularity
            property_count
            country {
              id
              value
              slug
            }
            main_media {
              id
              url
              name
            }
            slug
          }
        }
      }
    `,
    pause: isServer,
    variables: {
      orderBy: [{
        column: 'POPULARITY',
        order: 'DESC',
      }],
    },
  })

  const [{ data: countries, fetching: fetchingCountries }] = useQuery({
    query: gql`
      query Regions {
        countries(first: 50) {
          data {
            id
            value
            slug
          }
        }  
      }
    `,
    pause: isServer,
  })

  if (isServer || fetchingRegions || fetchingCountries) {
    return <></>
  }

  return (
    <div className="flex flex-col border-t border-grey-150 py-150">
      <div className="flex flex-col w-full container-public">
        <h1 className="font-serif font-bold text-32 lg:text-48 leading-title tracking-title">
          Get inspired for your next getaway
        </h1>

        <div className="flex pr-20 -mr-20 overflow-x-auto font-semibold border-b sm:px-0 sm:mx-0 scrollbar-hidden gap-x-50 whitespace-nowrap mt-60 text-grey-750 tracking-1/2 text-14 leading-20 border-grey-250">
          <div>
            <button
              className={`border-b-2 py-[9px] border-0 ${selectedDestination === -1 ? 'border-primary' : 'border-transparent'}`}
              onClick={() => setSelectedDestination(-1)}
            >
              POPULAR DESTINATIONS
            </button>
          </div>

          {(countries?.countries?.data ?? []).map(country => (
            <div key={country.id}>
              <button
                className={`border-b-2 py-[9px] border-0 ${selectedDestination === country?.id ? 'border-primary' : 'border-transparent'}`}
                onClick={() => setSelectedDestination(country?.id ?? -1)}
              >
                {country.value.toUpperCase()}
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="self-center w-full mt-60">
        <CarouselGetInspired
          featuredRegions={selectedDestination === -1
            ? regions?.regions?.data ?? []
            : (regions?.regions?.data ?? []).filter(region => region?.country?.id === selectedDestination)
          }
        />
      </div>
    </div>
  )
}

export default GetInspiredSection
